export function getMobileBottomNavOffset(): number {
  const navBarElement = document.querySelector(".mobile-bottom-nav") as HTMLElement | null;
  return navBarElement?.offsetHeight ?? 0;
}
